(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const dialog = document.getElementById('ctw-newsletter-dialog');
    if (!dialog || dialog.dataset.ready === 'true') return;
    dialog.dataset.ready = 'true';
    const state = dialog.querySelector('[data-ctw-state]');
    const backdrop = document.querySelector('[data-ctw-backdrop]');
    const storageKey = 'couturierista-welcome10-dismissed-v2';
    let timer;
    let lastTrigger;
    const open = trigger => {
      clearTimeout(timer);
      lastTrigger = trigger || null;
      backdrop.hidden = false;
      if (!dialog.open) dialog.show();
    };
    const remember = () => {
      try { localStorage.setItem(storageKey, String(Date.now())); } catch (_) {}
    };
    const close = () => {
      remember();
      dialog.close();
      backdrop.hidden = true;
      lastTrigger?.focus();
    };
    document.querySelectorAll('[data-ctw-open]').forEach(trigger => trigger.addEventListener('click', event => { event.preventDefault(); open(trigger); }));
    dialog.querySelector('[data-ctw-close]').addEventListener('click', close);
    backdrop.addEventListener('click', close);
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
    });
    dialog.querySelector('[data-ctw-copy]')?.addEventListener('click', async event => {
      const button = event.currentTarget;
      try {
        await navigator.clipboard.writeText('WELCOME10');
        button.textContent = button.dataset.copiedLabel;
      } catch (_) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(dialog.querySelector('.ctw-code'));
        selection.removeAllRanges();
        selection.addRange(range);
      }
    });
    let dismissed = 0;
    try { dismissed = Number(localStorage.getItem(storageKey)) || 0; } catch (_) {}
    if (state.dataset.success === 'true' || state.dataset.errors === 'true') {
      timer = setTimeout(() => open(), 100);
    } else if (Date.now() - dismissed > 14 * 24 * 60 * 60 * 1000) {
      timer = setTimeout(() => open(), 5000);
    }
    window.addEventListener('pagehide', () => clearTimeout(timer), { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
